import { useState, useCallback, useEffect } from "react";
import {
  loadSavedLocation,
  getCoordinates,
  fetchCurrentWeatherText,
} from "@/lib/weatherUtils";

interface WeatherAutoFillResult {
  autoWeather: string;
  locationLabel: string;
  autoFillLoading: boolean;
  refetchWeather: () => void;
}

export function useWeatherAutoFill(): WeatherAutoFillResult {
  const [autoWeather, setAutoWeather] = useState("");
  const [locationLabel, setLocationLabel] = useState("");
  const [autoFillLoading, setAutoFillLoading] = useState(false);

  const refetchWeather = useCallback(async () => {
    const saved = loadSavedLocation();
    if (!saved) return;

    const label = saved.district
      ? `${saved.province} ${saved.district}`
      : saved.province;

    setLocationLabel(label);
    setAutoFillLoading(true);

    try {
      const coords = await getCoordinates(saved.province, saved.district);
      if (!coords) return;

      const weatherText = await fetchCurrentWeatherText(coords.latitude, coords.longitude);
      if (weatherText) {
        setAutoWeather(weatherText);
      }
    } finally {
      setAutoFillLoading(false);
    }
  }, []);

  useEffect(() => {
    refetchWeather();
  }, [refetchWeather]);

  return { autoWeather, locationLabel, autoFillLoading, refetchWeather };
}